export type MpnMergeCandidateRow = {
  collection: 'stagedProducts' | 'canonicalProducts';
  id: string;
  name: string;
  sku: string;
  stagingStatus?: string;
  status?: string;
  fieldsPresentOnCandidate: string[];
  fieldsPresentOnCurrentMissingOnCandidate: string[];
  recommendMerge: boolean;
};

/**
 * Drop rows that are already explained elsewhere on the staged detail dialog
 * (the linked catalog product, or a prior promote artifact for this SKU).
 */
export function visibleMpnMergeCandidates<T extends MpnMergeCandidateRow>(
  candidates: T[] | undefined,
  opts?: {
    existingCanonicalId?: string;
    promotedStagedIds?: string[];
  },
): T[] {
  const promoted = new Set(opts?.promotedStagedIds || []);
  return (candidates || []).filter((row) => {
    if (!row.recommendMerge) return false;
    if (row.collection === 'canonicalProducts' && opts?.existingCanonicalId && row.id === opts.existingCanonicalId) {
      return false;
    }
    if (row.collection === 'stagedProducts' && promoted.has(row.id)) return false;
    return true;
  });
}

export function mpnMergeCandidateKind(row: Pick<MpnMergeCandidateRow, 'collection' | 'stagingStatus'>): string {
  if (row.collection === 'canonicalProducts') return 'Catalog product';
  if (row.stagingStatus === 'promoted') return 'Old promoted scrape';
  return 'Another staged scrape';
}
